import { MultipleLocalStorageKeys } from 'constants/local-storage';

export const UNIT_SYSTEM = {
    imperial: 'imperial'
};

export const getUnitSystem = () => localStorage.getItem(MultipleLocalStorageKeys.bodyHeightWeightKeys.unitSystem);
